/*
 *  -----------------------------------------------------------------------
 *    <copyright file="home/welcome.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';
import { useTranslation } from 'hooks';
import { formatDateUTC_DEPRECATED } from 'utils/convertor';
import ItemWrapper from 'views/components/core/item-wrapper';
import './home-styles.scss';

const HomeWelcome = ({ user, noStudies }: any) => {
    const { t } = useTranslation();

    return (
        <ItemWrapper hideItemNumber title={t('welcome')} customStyle={{ height: '100%' }} darkTitle>
            <div className="welcome-home-info">
                {noStudies && !user.systemAdminLevel ? (
                    <p className="no-studies">{t('home:userNoStudies')}</p>
                ) : (
                    <>
                        <p className="welcome-home-text">
                            <span className="title">{t('name')}:</span>
                            {user.firstName} {user.lastName}
                        </p>
                        {user.previousLoginTime ? (
                            <p className="welcome-home-text">
                                <span className="title">{t('home:lastSignedIn')}:</span>
                                {formatDateUTC_DEPRECATED(user.previousLoginTime, true, 'DD-MMM-YYYY HH:mm:ss')} UTC
                            </p>
                        ) : null}
                    </>
                )}
            </div>
        </ItemWrapper>
    );
};

export default HomeWelcome;
